import './App.css';
import AddTodo from './components/AddTodo';
import FilterButtons from './components/FilterButtons';
import TodoList from './components/TodoList';

function App() {
  return (
    <div className="App">
      <h1>Todo App</h1>
      <AddTodo />
      <FilterButtons />
      <TodoList />
    </div>
  );
}

export default App;
